import styled from 'styled-components/macro';
import * as colors from 'components/common/colorConstants';
import { smallScreens, mediumScreens, largeWidthScreen, TicketTextRegular } from 'components/common/fontElements';
import { Root as TranslationInfo } from 'components/Messages/TranslationInfo/TranslationInfo.styles';
import { IconDebugIconOutlined } from 'components/common/SVGIcons';

export const Wrapper = styled.div`
  display: flex;
  direction: row;
  justify-content: ${(props) => (props.isCustomerMessage ? 'flex-start' : 'flex-end')};
  align-items: flex-start;
  animation-name: fadeIn;
  animation-duration: 0.3s;
  animation-fill-mode: forwards;
  opacity: 0%;

  @keyframes fadeIn {
    0% {
      opacity: 0%;
    }
    100% {
      opacity: 100%;
    }
  }

  &:last-child {
    margin-bottom: 20px;
  }
`;

export const WhiteSpaceNormalizeWrapper = styled(TicketTextRegular)`
  white-space: normal;

  .label {
    white-space: normal;
  }
`;

export const InlineBlockComponent = styled.div`
  display: inline-flex;
  line-height: 1;
  align-items: center;
`;

export const ChatMessageBox = styled.div`
  display: flex;
  padding: ${(props) => (!props.isCustomerMessage && props.isFlowDebugStateEnabled ? '6px 24px 6px 8px' : '6px 8px')};
  margin-bottom: ${(props) => (props.isFlowDebugStateEnabled ? '12px' : '0')};
  min-height: 29px;
  white-space: pre-wrap;
  position: relative;
  border-radius: 4px;
  width: fit-content;
  border: ${(props) => props.addBorder && `1px solid ${colors.lightGray6}`};
  justify-self: right;

  p {
    margin: 0px;
  }

  ${TranslationInfo} {
    position: absolute;
    inset: auto -6px -6px auto;
  }
`;

export const ChatMessage = styled.div`
  max-width: 60%;
  padding: ${(props) => (props.isCustomerMessage ? '10px 10px 10px 20px' : '10px 20px 10px 10px')};

  @media screen and (max-width: ${largeWidthScreen}) {
    max-width: 80%;
  }
  @media screen and (max-width: ${mediumScreens}) {
    max-width: 90%;
  }
  @media screen and (max-width: ${smallScreens}) {
    max-width: 100%;
  }
`;

export const ChatContent = styled.div`
  display: flex;
  flex-direction: ${(props) => (props.isCustomerMessage ? 'row' : 'row-reverse')};
`;

export const ChatSentStatusMarker = styled.div`
  padding: 0px 10px;
  margin-right: 30px;
  font-size: 10px;
  white-space: normal;
  display: inline-block;
  font-size: 7px;
  line-height: 7px;
  min-width: 100px;
  color: ${(props) => (props.color ? props.color : colors.lightGray2)};
`;

export const MessageHeader = styled.div`
  justify-content: space-between;
  flex-direction: row;
  display: flex;
  font-size: 11px;
  color: ${colors.lightBlack};
  font-family: 'Lato-Light', sans-serif;
  margin-bottom: 0.8rem;
`;

export const ChatMessageHeader = styled(MessageHeader)`
  width: 100%;
  flex-direction: ${(props) => (props.isCustomerMessage ? 'row' : 'row-reverse')};
  padding: ${(props) => (props.isCustomerMessage ? '0px 10px 0px 35px' : '0px 35px 0px 0px')};
`;

export const SMBReplyMessageBody = styled(TicketTextRegular)`
  font-size: 9px;
  color: ${colors.lightBlack};
  margin: ${(props) => (props.isLiveChat ? '0px 30px 0px 10px' : '0px 0px 0px 15px')};
  margin-left: 15px;
`;

export const LinkIcon = styled.img`
  margin: 0px 5px 0px 0px;
  padding: 0;
`;

export const CustomerLocation = styled.div`
  color: ${colors.lightBlack};
  font-size: 9px;
  display: flex;
  flex-direction: row;
  line-height: 1;
  align-items: center;
  margin: 0px 0px 0px 0px;
  text-decoration-line: underline;
  padding: 39px 0px 20px 0px;
  &:hover {
    cursor: pointer;
  }

  p {
    line-height: 1;
    margin: 0px 0px 5px 0px;
  }
`;

export const AttachmentWrapper = styled.section`
  padding: ${(props) => (props.addTopPadding ? '15px 0px 15px 0px' : '0px 0px 15px 0px')};
  white-space: pre-wrap;
  width: 100%;
  position: relative;
`;

export const MainChat = styled.section`
  padding: 0px 9px;
`;

export const InspectorButton = styled(IconDebugIconOutlined)`
  visibility: ${(props) => (props.isInspectorVisible ? 'visible' : 'hidden')};
  position: absolute;

  bottom: -8px;
  right: -8px;

  border: 1px solid ${colors.lightGray21};
  background-color: ${colors.lightGray21};
  border-radius: 4px;
  color: ${colors.black2};

  width: 24px;
  height: 24px;

  cursor: pointer;
`;
